module.exports = __webpack_public_path__ + "img/equifax-engage-logo.bd0a8a51.png";